/* FalPé Digital — buscador por título/handle: añade al final los productos más antiguos (página 2+ de la colección all) */
(function () {
  function init() {
    var list = document.querySelector('product-list[data-falpe-pages]');
    if (!list) return;
    var pages = parseInt(list.getAttribute('data-falpe-pages') || '1', 10) || 1;
    if (pages < 2) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var q = list.getAttribute('data-falpe-terms') || '';
    var reqs = [];
    for (var i = 2; i <= pages; i++) {
      reqs.push(fetch(root + 'search?q=' + encodeURIComponent(q) + '&view=falpe-results&page=' + i, { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
    }
    Promise.all(reqs).then(function (texts) {
      var added = 0;
      var seen = {};
      Array.prototype.slice.call(list.children).forEach(function (el) {
        var h = el.getAttribute('handle');
        if (h) seen[h] = true;
      });
      texts.forEach(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var hits = d.getElementById('falpe-hits');
        if (!hits) return;
        Array.prototype.slice.call(hits.children).forEach(function (el) {
          var h = el.getAttribute('handle');
          if (h && seen[h]) return;
          if (h) seen[h] = true;
          list.appendChild(document.importNode(el, true));
          added++;
        });
      });
      if (!added) return;
      var total = list.children.length;
      var count = document.querySelector('[data-falpe-count]');
      if (count) count.innerHTML = count.innerHTML.replace(/\d[\d.,]*/, String(total));
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
